import PregnancyWarning from './PregnancyWarning';

export default PregnancyWarning;
